module.exports = __webpack_public_path__ + "img/violet_146.ca29998e.png";